export enum EsferasAvaliacaoSgsiaEnum {
    CONSORCIO = 'CONSORCIO',
    DISTRITAL = 'DISTRITAL',
    MUNICIPAL = 'MUNICIPAL',
    ESTADUAL = 'ESTADUAL',
}

export class EsferaAvaliacaoSgsia{
    //converte csServicoInspecao para esfera de avaliação
    static csServicoInspecaoToEsferaAvaliacao(csServicoInspecao: string): EsferasAvaliacaoSgsiaEnum | undefined {
        switch (csServicoInspecao) {
            case 'C':
                return EsferasAvaliacaoSgsiaEnum.CONSORCIO;
            case 'D':
                return EsferasAvaliacaoSgsiaEnum.DISTRITAL;
            case 'E':
                return EsferasAvaliacaoSgsiaEnum.ESTADUAL;
            case 'M':
                return EsferasAvaliacaoSgsiaEnum.MUNICIPAL;
            default:
                return undefined;
        }
    }

    static descricaoEsferaAvaliacao(esfera: EsferasAvaliacaoSgsiaEnum): string {
        switch (esfera) {
            case EsferasAvaliacaoSgsiaEnum.CONSORCIO:
                return 'Consórcio';
            case EsferasAvaliacaoSgsiaEnum.DISTRITAL:
                return 'Distrital';
            case EsferasAvaliacaoSgsiaEnum.MUNICIPAL:
                return 'Municipal';
            case EsferasAvaliacaoSgsiaEnum.ESTADUAL:
                return 'Estadual';
            default:
                return esfera;
        }
    }


}
